import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSignup } from '../SignupContext';

function Riga({ label, value }: { label: string; value?: string | boolean }) {
  const display =
    value === undefined || value === '' || value === false ? '—' : String(value);
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '180px 1fr' },
        gap: { xs: 0.5, sm: 3 },
        py: 1.5,
        borderBottom: '1px solid var(--dust)',
      }}
    >
      <Typography
        sx={{
          fontFamily: '"JetBrains Mono Variable", monospace',
          fontSize: '0.7rem',
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          color: 'var(--ink-soft)',
          pt: 0.3,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontFamily: '"Plus Jakarta Sans Variable", sans-serif',
          fontSize: '1rem',
          color: 'var(--ink)',
        }}
      >
        {display}
      </Typography>
    </Box>
  );
}

function GruppoSezione({ titolo, children }: { titolo: string; children: React.ReactNode }) {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        sx={{
          fontFamily: '"Fraunces Variable", Georgia, serif',
          fontSize: '1.4rem',
          fontWeight: 500,
          color: 'var(--ink)',
          letterSpacing: '-0.01em',
          mb: 1,
        }}
      >
        {titolo}
      </Typography>
      <Box>{children}</Box>
    </Box>
  );
}

export default function StepRiepilogo() {
  const { state } = useSignup();
  const { t } = useTranslation('signup');

  return (
    <Stack spacing={4}>
      <Box>
        <Typography
          variant="h2"
          sx={{
            fontFamily: '"Fraunces Variable", Georgia, serif',
            fontSize: { xs: '2.4rem', md: '3.2rem' },
            letterSpacing: '-0.02em',
            lineHeight: 1,
            mb: 2,
          }}
        >
          {t('step_riepilogo.titolo')}
        </Typography>
        <Typography
          variant="body1"
          sx={{ color: 'var(--ink-soft)', maxWidth: 540, fontSize: '1.05rem' }}
        >
          {t('step_riepilogo.descrizione')}
        </Typography>
      </Box>

      <Box
        sx={{
          padding: '20px 24px',
          background: 'var(--bg-deep)',
          border: '1px solid var(--dust)',
          borderLeft: '3px solid var(--sun)',
        }}
      >
        <Typography
          sx={{
            fontFamily: '"JetBrains Mono Variable", monospace',
            fontSize: '0.78rem',
            letterSpacing: '0.04em',
            color: 'var(--ink-soft)',
            lineHeight: 1.6,
          }}
        >
          <strong style={{ color: 'var(--ink)' }}>
            {t('step_riepilogo.beta_banner_titolo')}
          </strong>{' '}
          {t('step_riepilogo.beta_banner_testo')}
        </Typography>
      </Box>

      <Box>
        <GruppoSezione titolo={t('step_riepilogo.sezione_ruolo')}>
          <Riga label={t('step_riepilogo.riga_tipologia')} value={state.ruolo} />
        </GruppoSezione>

        <GruppoSezione titolo={t('step_riepilogo.sezione_azienda')}>
          <Riga label={t('step_riepilogo.riga_ragione_sociale')} value={state.ragione_sociale} />
          <Riga label={t('step_riepilogo.riga_piva')} value={state.partita_iva} />
          <Riga label={t('step_riepilogo.riga_indirizzo')} value={state.sede_via} />
          <Riga
            label={t('step_riepilogo.riga_citta')}
            value={`${state.sede_cap ?? ''} ${state.sede_citta ?? ''} (${state.sede_provincia ?? ''})`}
          />
          <Riga label={t('step_riepilogo.riga_regione')} value={state.sede_regione} />
        </GruppoSezione>

        <GruppoSezione titolo={t('step_riepilogo.sezione_admin')}>
          <Riga
            label={t('step_riepilogo.riga_nome_cognome')}
            value={`${state.admin_nome ?? ''} ${state.admin_cognome ?? ''}`}
          />
          <Riga label={t('step_riepilogo.riga_email')} value={state.admin_email} />
          <Riga label={t('step_riepilogo.riga_telefono')} value={state.admin_telefono} />
        </GruppoSezione>
      </Box>
    </Stack>
  );
}
